export default __webpack_public_path__ + "0bd6368feeb21ceb7bb636e34d50d2ef.png";